@if (cameraGroup.state) {
  <div class="card monitor">
    <div class="card-header">
      <strong>{{cameraGroup.name}}</strong>
      <div class="float-right">
        @if (user.roleLevel >= 100 || user.roleLevel === 40) {
          <span class="fa-light fa-fw fa-lg fa-id-badge cursorPointer" (click)="editProfile()"
          ></span>
        }
        @if (cameraGroup.id && cameraGroup.cameras && (user.roleLevel >= 100 || user.roleLevel === 40)) {
          <a class="ml-3"
            [routerLink]="'zones/'+cameraGroup.id"><span class="fa-light fa-fw fa-lg fa-vector-square"></span></a>
          }
        </div>
        <div class="mt-1 mb-1">
          @if (!profileEdit) {
            <div>
              @if (cameraGroup.activeProfile) {
                <span>{{cameraGroup.activeProfile.name}}</span>
              }
            </div>
          }
          @if (profileEdit) {
            <div class="form mt-2">
              <div class="form-group">
                <mat-form-field class="selector-full-width">
                  <mat-label>{{'DEFAULT_PROFILE' |translate}}</mat-label>
                  <mat-select [(ngModel)]="selectedDefaultProfile">
                    @for (profile of profiles; track profile) {
                      <mat-option [value]="profile">
                        {{profile.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field class="selector-full-width">
                  <mat-label>{{'SCHEDULED_PROFILE' |translate}}</mat-label>
                  <mat-select [(ngModel)]="selectedScheduledProfile">
                    <mat-option [value]=null>{{'DISABLED' |translate}}</mat-option>
                    @for (profile of profiles; track profile) {
                      <mat-option [value]="profile">
                        {{profile.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              @if (selectedScheduledProfile) {
                <div class="form-row">
                  <div class="form-group col-xl-6">
                    <label>{{'REPORT_START_TIME' |translate}}</label>
                    <input type="text" class="form-control" [(ngModel)]="selectedScheduledProfileStartTime">
                  </div>
                  <div class="form-group col-xl-6">
                    <label>{{'REPORT_END_TIME' |translate}}</label>
                    <input type="text" class="form-control" [(ngModel)]="selectedScheduledProfileStopTime">
                  </div>
                </div>
              }
              <div class="form-group">
                <button (click)="saveProfile()" class="btn btn-outline-primary mr-2">{{'SAVE' |translate}}</button>
                <button (click)="editProfile()" class="btn btn-outline-danger">{{'CANCEL' |translate}}</button>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="card-body">
        @if (cameraGroup.state.state !== 'disabled') {
          <div>
            <div class="row mb-1">
              @if (cameraGroup.alerts?.length) {
                <div class="float-left ml-3 mt-3">
                  <span class="fa-solid fa-3x fa-exclamation text-danger"></span>
                </div>
              }
              <div class="float-left ml-3">
                @if (cameraGroup.state.state) {
                  <img [src]="getIconPath(cameraGroup.state.state)" class="apStateIcon" alt=""
                    >
                }
              </div>
              <div class="float-left ml-3">
                <strong>{{getIconText()}}</strong><br>
                @if (cameraGroup.state.state !== 'unknown') {
                  <span>@if (this.cameraGroup.state.time && this.cameraGroup.state.time !== '0001-01-01T00:00:00Z') {
                    <span
                      >{{'STARTED'|translate}}:
                      {{cameraGroup.state.time |moment: 'LT'}} <br>({{calculateStateDuration()}})</span>
                    }</span>
                  }
                </div>
              </div>
              <!-- Show notification if cameraGroup has an active alert -->
              @if (cameraGroup.alerts) {
                <div class="mt-2">
                  @for (alert of cameraGroup.alerts; track alert) {
                    <div class="alert alertActive alert-danger"
                      [ngClass]="{'alert-danger' : !alert.taskStartedBy, 'alert-success': alert.taskStartedBy}"
                      >
                      <span class="fa-light fa-fw fa-bell"></span> {{alert.type |translate}}
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    }